import { render } from "./FormTextArea.vue?vue&type=template&id=d49b7a9c&scoped=true"
import script from "./FormTextArea.vue?vue&type=script&lang=js"
export * from "./FormTextArea.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d49b7a9c"

export default script